import React, { useState, useEffect, useCallback } from "react";
import { Progress } from "../ui/progress";
import { Button } from "../ui/button";
import { Badge } from "../ui/badge";
import { listSessions } from "../../api";

// currentQuestion id → 中文題目名稱
const QUESTION_LABEL = {
  location: "場域地點", roomCount: "房間/帳篷數", maxGuests: "最多可住人數",
  occupancyRate: "目前住房率", occHint: "住房率提示", monthlyRevenue: "目前月營收",
  projection: "成長試算", runningAds: "是否投廣告", adsHint: "廣告提示",
  kolCooperation: "網紅合作", kolHint: "網紅提示", targetRevenue: "目標月營收",
  avgPrice: "平均單價", decisionMaker: "合作決定權", visitedLakeze: "到過人客多場域",
  name: "稱呼", venueSocial: "場域 FB/IG", lineDisplayName: "LINE 顯示名稱",
  lineId: "LINE ID", phone: "聯絡電話", email: "電子信箱", review: "確認頁",
};

export default function SessionsTable() {
  const [page, setPage] = useState(1);
  const [data, setData] = useState({ sessions: [], total: 0, pages: 1 });
  const [loading, setLoading] = useState(true);

  const load = useCallback(() => {
    setLoading(true);
    listSessions({ page, status: "in_progress" })
      .then(setData)
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [page]);

  useEffect(() => { load(); }, [load]);

  const rows = data.sessions;

  return (
    <div className="space-y-4">
      <div className="rounded-xl border border-amber-200 bg-amber-50 p-3 text-sm text-amber-700">
        這裡是「已開始填寫但尚未送出」的訪客。聯絡資訊在問卷最後才填，越後面停下的人，留下的資訊越完整、越值得跟進。
      </div>

      <div className="overflow-x-auto rounded-xl border border-border bg-white shadow-sm">
        <table className="w-full min-w-[980px] text-sm">
          <thead className="bg-secondary text-left text-xs text-muted-foreground">
            <tr>
              <th className="px-3 py-3">開始時間</th>
              <th className="px-3 py-3">最後更新</th>
              <th className="px-3 py-3 w-40">進度</th>
              <th className="px-3 py-3">停在哪一題</th>
              <th className="px-3 py-3">稱呼</th>
              <th className="px-3 py-3">電話</th>
              <th className="px-3 py-3">LINE</th>
              <th className="px-3 py-3">場域地點</th>
              <th className="px-3 py-3">月營收</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {loading && <tr><td colSpan={9} className="px-3 py-10 text-center text-muted-foreground">載入中…</td></tr>}
            {!loading && rows.length === 0 && <tr><td colSpan={9} className="px-3 py-10 text-center text-muted-foreground">目前沒有未完成的填寫</td></tr>}
            {!loading && rows.map((s) => {
              const d = s.data || {};
              return (
                <tr key={s.id} className="hover:bg-amber-50/40">
                  <td className="whitespace-nowrap px-3 py-3 text-xs text-muted-foreground">{new Date(s.startedAt).toLocaleString("zh-TW", { hour12: false })}</td>
                  <td className="whitespace-nowrap px-3 py-3 text-xs text-muted-foreground">{new Date(s.updatedAt).toLocaleString("zh-TW", { hour12: false })}</td>
                  <td className="px-3 py-3">
                    <div className="flex items-center gap-2">
                      <Progress value={s.progress || 0} className="h-2 w-24" />
                      <span className="text-xs font-medium">{s.progress || 0}%</span>
                    </div>
                  </td>
                  <td className="px-3 py-3">
                    <Badge variant="secondary" className="font-normal">{QUESTION_LABEL[s.currentQuestion] || "—"}</Badge>
                  </td>
                  <td className="px-3 py-3">{d.name || "—"}</td>
                  <td className="px-3 py-3">{d.phone || "—"}</td>
                  <td className="px-3 py-3">{d.lineDisplayName || d.lineId || "—"}</td>
                  <td className="px-3 py-3">{d.location === "其他" ? d.locationOther : d.location || "—"}</td>
                  <td className="px-3 py-3">{d.monthlyRevenue || "—"}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <div className="flex items-center justify-between text-sm">
        <span className="text-muted-foreground">共 {data.total} 筆未完成 · 第 {page}/{data.pages} 頁</span>
        <div className="flex gap-2">
          <Button variant="outline" size="sm" disabled={page <= 1} onClick={() => setPage((p) => p - 1)}>上一頁</Button>
          <Button variant="outline" size="sm" disabled={page >= data.pages} onClick={() => setPage((p) => p + 1)}>下一頁</Button>
        </div>
      </div>
    </div>
  );
}
